import './download-mobile-app.scss'
import React, {useMemo} from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {PermissionsChecker} from '@client/permissions-checker'
import {Tracking, TrackingEvent} from '@common/tracking'
import {globals} from '@extensions/globals-base'
import {Project} from '@extensions/project'
import {UserAccess} from '@extensions/user-access'
import AndroidIcon from './android.svg'
import AppleIcon from './apple.svg'
import Gradient from './gradient.svg'
import HuaweiIcon from './huawei.svg'
import Phone from './phone.svg'

export const DownloadMobileApp: React.FC = () => {
  const isAdminOrManager = useMemo(() => {
    const isAdmin = PermissionsChecker.isAdmin()
    if (isAdmin) {
      return true
    }
    const companyId = globals.getCompanyId()
    const allProjects = Project.listProjects(companyId, 'not-archive')
    const isManager = allProjects.some(
      project =>
        UserAccess.getRoleInProject(globals.currentUserId, project) === 'admin'
    )
    return isManager
  }, [])

  const descriptionLine1 = isAdminOrManager
    ? Lang.msg.mobileAppBannerTitleAdmin
    : Lang.msg.mobileAppBannerTitleNotAdmin
  const descriptionLine2 = isAdminOrManager
    ? Lang.msg.mobileAppBannerTextAdmin
    : Lang.msg.mobileAppBannerTextNotAdmin

  const bem = Util.bemFrom('download-mobile-app')

  return (
    <div className={bem('container')}>
      <div className={bem('content')}>
        <div className="flex flex-row justify-between gap-12">
          <div>
            <div className="text-generic-white text-24 xl:text-20 font-bold mb-8">
              {Lang.msg.mobileAppBannerTitle}
            </div>
            <div className="text-generic-white text-16 xl:text-14">
              {descriptionLine1}
            </div>
            <div className="text-generic-white text-16 xl:text-14 mb-24">
              {descriptionLine2}
            </div>
          </div>
        </div>
      </div>
      <div className={bem('stores')}>
        <div className="flex flex-row gap-8 items-center">
          <a
            href="https://apps.apple.com/ru/app/yougile-mobile/id1502267175"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              Tracking.send(TrackingEvent.profileClickOnDownloadAppleButton)
            }}
          >
            <AppleIcon className="h-32 xl:h-28" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.yougile.mobile&pli=1"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              Tracking.send(TrackingEvent.profileClickOnDownloadAndroidButton)
            }}
          >
            <AndroidIcon className="h-32 xl:h-28" />
          </a>
          <a
            href="https://appgallery.huawei.com/app/C111250679"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              Tracking.send(
                TrackingEvent.profileClickOnDownloadAppGalleryButton
              )
            }}
          >
            <HuaweiIcon className="h-32 xl:h-28" />
          </a>
        </div>
      </div>
      <Gradient className={bem('gradient')} />
      <Phone className={bem('phone')} />
    </div>
  )
}
